import { createSelector } from 'reselect';
import { getUiState, iterationEndDate, numOfDaysInIteration } from './helpers';
import { PERIODS } from 'components/PeriodPicker/periods/constants';
import { hasAllTeamsScopeSelector } from 'state/selectors/account';

const getTeams = state => state.currentTeams;

export const uiStateSelector = state => state.uiState;

// this is made because thinking about the remove all teams synthetic group in the future. so will only need to change this selector logic;
export const shouldShowAllTeamsModeSelector = createSelector(
  hasAllTeamsScopeSelector,
  hasAllTeamsScope => hasAllTeamsScope
);
export const isVPModeSelector = createSelector(
  [getUiState, shouldShowAllTeamsModeSelector],
  ({ selectedTeamId }, shouldShowAllTeamsMode) =>
    !selectedTeamId && shouldShowAllTeamsMode
);

export const dateRangeSelector = createSelector(
  [getUiState],
  ({ dates }) => dates
);

export const selectedPeriodKeySelector = createSelector(
  [getUiState],
  ({ selectedPeriodKey = PERIODS.ITERATIONS.periodKey }) => selectedPeriodKey
);

export const isIterationsPeriodKeySelectedSelector = createSelector(
  [selectedPeriodKeySelector],
  selectedPeriodKey => selectedPeriodKey === PERIODS.ITERATIONS.periodKey
);

export const selectedTeamSelector = createSelector(
  [getUiState, getTeams],
  ({ selectedTeamId }, teams) => teams.find(({ id }) => id === selectedTeamId)
);

export const actualIterationEndDate = createSelector(
  [getUiState],
  ({ dates: { to } = {} }) => {
    return iterationEndDate(to);
  }
);

export const numOfDaysInIterationSelector = createSelector(
  [getUiState, actualIterationEndDate],
  ({ dates: { from } = {} }, actualIterationEndDate) => {
    return numOfDaysInIteration(from, actualIterationEndDate);
  }
);

export const isProcessingReposSelector = createSelector(
  getUiState,
  ({ isProcessingRepos }) => isProcessingRepos
);
export const hasNoDataSelector = createSelector(
  getUiState,
  ({ hasNoData }) => hasNoData
);
export const isBlurredSelector = createSelector(
  getUiState,
  ({ isBlurred }) => isBlurred
);
export const sidebarSelector = createSelector(
  getUiState,
  ({ sidebar }) => sidebar
);
export const hasIterationsSelector = createSelector(
  getUiState,
  ({ hasIterations }) => hasIterations
);
export const selectedTeamChangedFromTopBarSelector = createSelector(
  getUiState,
  ({ selectedTeamChangedFromTopBar }) => selectedTeamChangedFromTopBar
);
